import { BackgroundCheckConfig } from '@/backend/features/background-check/defaults';
import { BackgroundCheckStatus } from '@/backend/features/background-check/types';

export function getAllBackgroundCheckStatuses(backgroundCheckTypesSetting: BackgroundCheckConfig['type']) {
    return Object.values(backgroundCheckTypesSetting).reduce<BackgroundCheckStatus[]>((previousValue, currentValue) => {
        currentValue.statuses.forEach(({ status }) => {
            if (!previousValue.includes(status)) {
                previousValue.push(status);
            }
        });

        return previousValue;
    }, []);
}
